export const useRestore = (
  getTrash,
  activeTab,
  handleCloseRestoreModal,
  handleRestoreIdeas,
  handleRestoreAttributes,
  handleRestoreComponents,
  handleRestoreProjects,
) => {
  const handleRestore = async () => {
    handleCloseRestoreModal();

    switch (activeTab) {
      case 0:
        await handleRestoreProjects();
        getTrash();
        break;
      case 1:
        await handleRestoreComponents();
        getTrash();
        break;
      case 2:
        await handleRestoreAttributes();
        getTrash();
        break;
      case 3:
        await handleRestoreIdeas();
        getTrash();
        break;
      default:
        console.error("Error: Invalid activeTab.");
    }
  };

  return { handleRestore };
};
